import { post, postData } from './http'
import global from '@/api/global'
var name = global.crm
var vgsName = 'vgs-driver-server2/driver2'
var payServer = global.payServer
var orderServer = 'order-server/order'

// 手机验证码
export const sendSmsCode = p => post(vgsName + '/api/sendSmsCode', p)
// 企业管理-企业信息
export const getUserDetail = p => post(name + '/register/getUserDetail', p)
// 资质审核
// 客户审核/车队审核列表查询
export const customerCheckList = p => post(name + '/registerInfo/list', p)
// 数据字典
export const dictionary = p => post(name + '/dictionary/getDictionaryList', p)
// 驳回/通过
export const auditingStatus = p => post(name + '/registerInfo/auditingStatus', p)
// 驳回/通过
export const auditingStatusCDZ = p => post(name + '/registerInfo/auditingStatusCDZ', p)
// 记录
export const zzauditHistory = p => post(name + '/tZzauditHistory/listAll', p)
// 车辆
export const listByCheck = p => post(vgsName + '/cVehicleInfo/listByCheck', p)
// 车辆类型
export const vehicleTypeList = p => post(vgsName + '/cVehicleType/list', p)
// 车牌颜色
export const VhcNoColourList = p => post(vgsName + '/cVhcNoColour/list', p)
// 车辆审核/驳回
export const updateCheckData = p => post(vgsName + '/cVehicleInfo/updateCheckData', p)
// 车辆记录
export const zzauditHistoryList = p => post(vgsName + '/t/zzaudit/history/listAll', p)
// 司机列表查询
export const driverInfoList = p => post(vgsName + '/cDriverInfo/listByCheck', p)
// 司机驳回
export const driverInfoUpdateCheckData = p => post(vgsName + '/cDriverInfo/updateCheckData', p)
// 认证信息修改
export const registerInfoUpdate = p => post(name + '/registerInfo/update', p)
// ----------------------------------------------------------
// 货主端-运费结算列表
export const sOrderList = p => post(orderServer + '/sOrder/list', p)
// 货主端-运费结算列表订单详情
export const getListWayByOrderNo = p => post(orderServer + '/api/getListWayByOrderNo', p)
// 平台端-结算-司机结算-列表
export const listForDriver = p => post(orderServer + '/way/listForSettlement', p)
// 运单详情
export const getbusinessNo = p => post(orderServer + '/way/getbusinessNo ', p)
// 货主端-财务管理-资金账户-查询用户对象列表
export const listAllCustomer = p => post(payServer + '/tAccountCustinfo/listAllCustomer', p)
// 货主端-财务管理-资金账户-列表
export const getPayList = p => post(payServer + '/tExternalTransdetai/list', p)
// 货主端-财务管理-资金账户-金额
export const getPayDetailByPC = p => post(payServer + '/tAccountCustinfo/getPayDetailByPC', p)
// 货主端-财务管理-资金账户-银行卡
export const addBankData = p => post(payServer + '/tAccountCustinfo/updateBankData', p)
// 货主端-财务管理-资金账户-设置密码
export const firstUpdateBankCardPayPwd = p => post(payServer + '/tAccountCustinfo/firstUpdateBankCardPayPwd', p)
// 货主端-财务管理-资金账户-修改密码
export const updateBankCardPayPwd = p => post(payServer + '/tAccountCustinfo/updateBankCardPayPwd', p)
// 货主端-财务管理-资金账户-提现
export const tWithdrawalInfoAdd = p => post(payServer + '/tWithdrawalInfo/add', p)
// 货主端-财务管理-资金账户-解绑
export const updateBankDataUntie = p => post(payServer + '/tAccountCustinfo/updateBankDataUntie', p)
// --------------------------------------------------------------------
// 货主端-财务管理-开票查询-处理进度数据
export const getDictionaryList = p => post(payServer + '/bPayDictionary/getDictionaryList', p)// 字典
// 平台端-发票管理-查看
export const invoiceModel = p => post(payServer + '/invoiceModel/getInvoiceByTenantCode', p)
// 平台端-结算管理-车队结算
export const tFleetBalanceAdd = p => post(payServer + '/tFleetBalance/add', p)
// 平台端-结算管理-司机结算-支付
export const driverBalanceAdd = p => post(payServer + '/driverBalance/add', p)
// 平台端-平台账户-资金账户列表
export const tPlateTransdetailList = p => post(payServer + '/tExternalTransdetai/list', p)
// 平台端-平台账户-修改密码
export const changePassWord = p => post(payServer + '/tAccountCustinfo/updateBankCardPayPwd', p)
// 货主端-资金账户-微信支付
export const wxNativePayUrl = p => post(payServer + '/wxNativePay/wxNativePayUrl', p)
// 车队端-资金账户-提现列表
export const tWithdrawalInfoList = p => post(payServer + '/tWithdrawalInfo/list', p)
// 车队端-资金账户-提现
// export const addByCars = p => post(payServer + '/tWithdrawalInfo/addByCars', p)
export const addWithdrawal = p => post(payServer + '/tWithdrawalInfo/addWithdrawal', p)
// 车队长-财务管理-运费收入
export const listCaptainForIncome = p => post(orderServer + '/way/listCaptainForIncome', p)
// 车队长结算列表
export const listCaptainForSettlement = p => post(orderServer + '/way/listCaptainForSettlement', p)
// 车队长支付
export const czdBalanceAdd = p => post(payServer + '/cdzBalance/add', p)
// 车队长-订单支付
export const addForOrder = p => post(payServer + '/cdzBalance/addForOrder', p)
// 车队长提现
export const addByCdz = p => post(payServer + '/tWithdrawalInfo/addByCdz', p)
// 车辆颜色
export const cVhcNoColour = p => post(vgsName + '/cVhcNoColour/list', p)
// 订单详情页面货物详情
export const getGoodListByDisId = p => post(orderServer + '/way/getGoodListByDisId ', p)
// 结算2.0接口========================================================
// 平台-用户余额-列表（现在是平台账户管理里面得列表）
export const tAccountCustinfoList = p => post(payServer + '/tAccountCustinfo/list', p)
// 平台-用户余额-查看中信账户
export const searchSjAmt = p => post(payServer + '/zCiticBankAccount/searchSjAmt', p)
// 货主端-财务管理-开票信息查询
export const getInvoiceModelDetail = p => post(payServer + '/invoiceModel/getInvoiceModelDetail ', p)
// 货主端-财务管理-开票信息新增
export const addReceipt = p => post(payServer + '/invoiceModel/addReceipt', p)
// 货主端-财务管理-开票信息修改
export const updateReceipt = p => post(payServer + '/invoiceModel/updateReceipt ', p)
// 货主端-财务管理-收票信息新增
export const addAddress = p => post(payServer + '/invoiceModel/addAddress', p)
// 货主端-财务管理-收票信息修改
export const updateAddress = p => post(payServer + '/invoiceModel/updateAddress', p)
// 申请发票列表
export const listApply = p => post(payServer + '/owner/invoice/listApply', p)
// 打包发票
export const confirmInvoice = p => post(payServer + '/owner/invoice/confirmInvoice', p)
// 发票列表
export const invoiceList = p => post(payServer + '/owner/invoice/list', p)
// 货主端-发票申请列表/平台-开票审核列表
export const tOwnerInvoiceBatchList = p => post(payServer + '/tOwnerInvoiceBatch/list', p)
// 单据列表
export const listSettles = p => post(payServer + '/owner/invoice/listSettles', p)
// 发票明细
export const paylist = p => post(payServer + '/pay/owner/invoice/list', p)
// 验证邮费
export const vailPostageMoney = p => post(payServer + '/owner/invoice/vailPostageMoney', p)
// 发票列表功能按钮
export const invoiceUpdates = p => post(payServer + '/owner/invoice/updates', p)
// 发票列表-通过/驳回
export const tOwnerInvoiceBatchUpdates = p => post(payServer + '/tOwnerInvoiceBatch/updates', p)
// 发票列表-根据申请流水查询结算单
export const detailByBusinessNo = p => post(payServer + '/upstreamSettlement/detailByBusinessNo', p)
// 平台端提现管理
export const offlineList = p => post(payServer + '/tWithdrawalInfo/offlineList', p)
// 平台-支出结算-列表
export const downstreamSettlementList = p => post(payServer + '/downstreamSettlement/list', p)
// 平台-支出结算-平台账户余额
export const toPayDetail = p => post(payServer + '/downstreamSettlement/toPayDetail', p)
// 下游合计费用明细
export const downstreamSettlementDetail = p => post(payServer + '/downstreamSettlementDetail/list', p)
// 平台-支出结算-支付
export const downstreamSettlementPayment = p => post(payServer + '/downstreamSettlement/payment', p)
// 税务明细
export const sTaxationDetail = p => post(payServer + '/sTaxationDetail/detailList', p)
// 平台端-收入结算列表-应收合计/货主端应付合计
export const upstreamsettlementDetailList = p => post(payServer + '/upstreamSettlementDetail/list', p)
// 货主端-运费支付/平台端收入结算
export const settlementList = p => post(payServer + '/upstreamSettlement/list', p)
// 平台结算管理-支出结算/收入结算 查看电子回单
export const bankReceipt = p => post(payServer + '/zCiticBankReceipt/bankReceipt', p)
// 获取账户列表接口
export const tAccountList = p => post(payServer + '/tAccountCustinfo/tAccountCustinfoList', p)
// 手动获取回单接口
export const manualBbankReceipt = p => post(payServer + '/zCiticBankReceipt/manualBbankReceipt', p)
// 货主运费支付查看电子回单
export const checkBankReceipt = p => post(payServer + '/upstreamSettlement/checkBankReceipt', p)
// 中信交易查看凭证
export const lookBankReceipt = p => post(payServer + '/bankReceipt/lookBankReceipt', p)
// 货主端调价记录
export const tModifyPriceRecordList = p => post(payServer + '/tModifyPriceRecord/list', p)
// 货主端调价
export const upstreamSettlementPric = p => post(payServer + '/upstreamSettlement/modifyPrice', p)
// 货主端调价
export const downstreamSettlementPric = p => post(payServer + '/downstreamSettlement/modifyPrice', p)
// 平台账户/获取司机银行卡信息
export const custInfoDetail = p => post(payServer + '/tAccountCustinfo/custInfoDetail', p)
// 货主-运费支付-账户余额
export const upToPayDetail = p => post(payServer + '/upstreamSettlement/toPayDetail', p)
// 货主-运费支付-支付
export const shipperPayment = p => post(payServer + '/upstreamSettlement/shipperPayment', p)
// 平台-运单税费-列表
export const sTaxationDetailList = p => post(payServer + '/sTaxationDetail/list', p)
// 平台-运单税费-运算
export const sTaxationSummaryAdd = p => post(payServer + '/sTaxationSummary/add', p)
// 平台-税务申报-列表
export const sTaxationSummaryList = p => post(payServer + '/sTaxationSummary/list', p)
// 平台-税务申报-个税上报
export const reportTax = p => post(payServer + '/sTaxationSummary/reportTax', p)
// 平台-税务申报-个税汇总上报
export const reportTaxSummary = p => post(payServer + '/sTaxationSummary/reportTaxSummary', p)
// 平台-税务申报-个税汇总详情
export const statisticsTaxSummary = p => post(payServer + '/sTaxationSummary/statisticsTaxSummary', p)
// 平台-税务申报-个税汇总列表
export const statisticsTaxSummaryList = p => post(payServer + '/sTaxationTaxSummary/list ', p)
// 平台-税务申报-其他税上报
export const reportSurtaxSummary = p => post(payServer + '/sTaxationSummary/reportSurtaxSummary', p)
// 银行回单列表
export const zCiticBankReceipt = p => post(payServer + '/zCiticBankReceipt/list', p)
// 交易明细
export const tExternalTransdetaiLIst = p => post(payServer + '/tExternalTransdetai/list', p)
// 平账记录
export const tBalanceAccounLIst = p => post(payServer + '/tBalanceAccount/list', p)
// 平账
export const pingZhang = p => post(payServer + '/tAccountCustinfo/balanceAccount', p)
// 声明审核列表
export const CDVauditList = p => post(vgsName + '/cDriverVehicleRel/auditList', p)
// 声明审核操作
export const CDVupdateAudit = p => post(vgsName + '/cDriverVehicleRel/updateAudit', p)
// 选择账户和账户设置得列表
export const platformAcclist = p => post(payServer + '/tAccountCustinfo/platformAcclist', p)
// 新增账户
export const platformAccountAdd = p => post(payServer + '/tAccountCustinfo/platformAccountAdd', p)
// 账户设置审核
export const auditAcc = p => post(payServer + '/tAccountCustinfo/auditAcc', p)
// 账户设置设为默认
export const updatePlatformAccDefault = p => post(payServer + '/tAccountCustinfo/updatePlatformAccDefault', p)
// 账户设置删除
export const delPlatformAcc = p => post(payServer + '/tAccountCustinfo/delPlatformAcc', p)
// 平台余额查询
export const platformAmountSum = p => post(payServer + '/downstreamSettlement/platformAmountSum', p)
// 验证支付密码是否正确
export const authenticationPwd = p => post(payServer + '/upstreamSettlement/authenticationPwd', p)
// 平台-划转记录
export const tTransMoneyInfoLIst = p => post(payServer + '/tTransMoneyInfo/list', p)
// 平台-资金划转
// export const tAccountCustinfoLIst = p => post(payServer + '/tAccountCustinfo/list', p)
// 资金划转
export const tranAccountMoney = p => post(payServer + '/tAccountCustinfo/tranAccountMoney', p)
// 平台开票-上报
export const invoiceReport = p => post(payServer + '/owner/invoice/invoiceReport', p)
// 平台-推送临时纳税人信息
export const reportTemporaryTaxpayerInfo = p => post(payServer + '/sTaxationSummary/reportTemporaryTaxpayerInfo', p)
// 货主端-运费结算-线下支付（常）
export const offlinePay = p => post(payServer + '/upstreamSettlement/offlinePay', p)
// 平台端-收入结算-线下收款（常）
export const offlineSettlement = p => post(payServer + '/upstreamSettlement/offlineSettlement', p)
// 平台端-收入结算-线下收款详情（常）
export const tOfflineReceipt = p => post(payServer + '/tOfflineReceipt/detail', p)
// 网络货运平台-运单上报列表（平）
export const sBusinessReportList = p => post(orderServer + '/sBusinessReport/list', p)
// 网络货运平台-运单上报状态（平）
export const updateReportStatus = p => post(orderServer + '/sBusinessReport/updateReportStatus', p)
// 油气对接=============================================================================
// 油气充值记录查询列表（何）
export const assignRecardList = p => post(payServer + '/gCardAssignRecard/assignRecardList', p)
// 油气消费记录查询列表（钱）
export const getG7CardExpenseTraderList = p => post(payServer + '/downstreamSettlement/getG7CardExpenseTraderList', p)
// 油气充值-总金额（钱）
export const getTotalMoney = p => post(payServer + '/gCardAssignRecard/getTotalMoney', p)
// 支付结算-油气余额账户（钱）
export const getAccCashList = p => post(payServer + '/downstreamSettlement/getAccCashList', p)
// 账户管理-开通油卡（钱）
export const addDriverFirstCard = p => post(payServer + '/downstreamSettlement/addDriverFirstCardpC', p)
// 支付结算-圈回（何）
export const recycleMoney = p => post(payServer + '/downstreamSettlement/recycleMoney', p)
// 支付结算-油气费详情（何）
export const oilDetailList = p => post(payServer + '/downstreamSettlementDetail/oilDetailList', p)
// 账户管理-油卡账户余额（平）
export const FuelCard = p => post(payServer + '/tAccountCustinfo/getFuelCard', p)
// 税务申报-上报记录（亚）
export const getReportRecordList = p => post(payServer + '/sTaxationSummary/getReportRecordList', p)
// 税务申报-临时纳税人上报记录（亚）
export const reportingTemporaryTax = p => post(payServer + '/sTaxationSummary/reportingTemporaryTax', p)
// 资金账户-充值备注（亚）
export const tDepartmentRecharging = p => post(payServer + '/departmentCustinfo/tDepartmentRecharging', p)
// （官网）累计运量、累计运费（亚）
export const cumulativeInfo = p => post(payServer + '/upstreamSettlement/cumulativeInfo', p)
// 平台批量支付（亚）
export const piLPaymentList = p => post(payServer + '/downstreamSettlement/piLPaymentList', p)
